import { get,post,put } from "../Config";


export function SearchCustomer({ params = {} }) {
  return get({ url: `/api/impact/v1/customer`, params });
}
export function GetProfile({ params = {} }) {
  return get({ url: `/api/impact/v1/customer/profile`, params });
}
export function GetCustomerProfile({ params }) {
  return get({ url: `/api/impact/v1/customer/line`, params });
}
export function PutUpdateCustomer({ params }) {
  return put({ url: `/api/impact/v1/customer/update`, params });
}
export function CreateCustomer({ params,data }) {
  return post({ url: `/api/impact/v1/customer/create`, params,data });
}
export function PostUpdateCustomer({ params,data }) {
  return post({ url: `/api/impact/v1/customer/update`, params,data });
}
export function PostArchievedCustomer({ params, data }) {
  return post({ url: `/api/impact/v1/archievedCustomer`, params, data });
}
export function PostCheckContactNumber({ params, data }) {
  return post({ url: `/api/impact/v1/checkContactNumber`, params, data });
}